<div class="action-btns text-right">
  @if (config.showEdit) {
    <a
      [routerLink]="cartLink"
      class="btn btn-flat p-0"
      (click)="onEditCart()"
      tooltip="{{'Edit'|translate}}">
      <i class="fa fa-pencil app-primary-color" aria-hidden="true"></i>
      <span class="d-lg-none app-primary-color" translate>Edit</span>
    </a>
    }&nbsp;
    @if (config.showUpdateAll) {
      <button
        type="button"
        class="btn btn-flat p-0"
        (click)="onUpdateAll()"
        tooltip="{{'Update All'|translate}}">
        <i class="fa fa-refresh app-primary-color" aria-hidden="true"></i>
        <span class="d-lg-none app-primary-color" translate>Update All</span>
      </button>
      }&nbsp;
      @if (config.showClearAll) {
        <button
          type="button"
          class="btn btn-flat p-0"
          (click)="onRemoveAll()"
          tooltip="{{'Clear All'|translate}}">
          <i class="fa fa-trash app-primary-color" aria-hidden="true"></i>
          <span class="d-lg-none app-primary-color" translate>Clear All</span>
        </button>
        }&nbsp;
      </div>
